import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Check, X, RefreshCw } from "lucide-react";

const YASAMARU_CHEER = "/yasamaru/cheer.png";

export default function BillingSuccess() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState({ checking: true, result: null });
  const [attempts, setAttempts] = useState(0);
  const [err, setErr] = useState("");
  const { refresh } = useAuth();

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      if (!sessionId) { setErr("session_idがありません"); setStatus({ checking: false, result: null }); return; }
      for (let i = 0; i < 8; i++) {
        if (cancelled) return;
        setAttempts(i + 1);
        try {
          const { data } = await api.get(`/billing/status/${sessionId}`);
          if (data.payment_status === "paid" || data.subscription_status === "trialing" || data.subscription_status === "active") {
            setStatus({ checking: false, result: "ok" });
            refresh && refresh();
            return;
          }
          if (data.status === "expired") {
            setStatus({ checking: false, result: "expired" });
            return;
          }
        } catch (e) {
          setErr(formatApiError(e.response?.data?.detail) || e.message);
        }
        await new Promise((r) => setTimeout(r, 2000));
      }
      setStatus({ checking: false, result: "timeout" });
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  return (
    <div className="min-h-screen bg-soft-mint flex items-center justify-center p-4">
      <div className="card-soft p-8 md:p-10 max-w-md w-full text-center">
        {status.checking ? (
          <>
            <RefreshCw className="text-emerald-500 mx-auto animate-spin" size={36} />
            <div className="font-display text-xl font-bold text-stone-900 mt-3">決済確認中...</div>
            <p className="text-sm text-stone-500 mt-1">少々お待ちください ({attempts}/8)</p>
          </>
        ) : status.result === "ok" ? (
          <>
            <img src={YASAMARU_CHEER} alt="やさまる" className="w-32 mx-auto" />
            <Check className="text-emerald-500 mx-auto" size={36} />
            <div className="font-display text-2xl font-black text-stone-900 mt-2">登録完了！</div>
            <p className="text-stone-600 mt-2 text-sm">14日間の無料お試しが始まりました。</p>
            <Link to={`/t/${slug}/admin`} data-testid="goto-admin-link" className="mt-6 inline-block rounded-full bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-6 py-2.5">管理画面へ</Link>
          </>
        ) : (
          <>
            <X className="text-rose-500 mx-auto" size={36} />
            <div className="font-display text-xl font-bold text-stone-900 mt-3">
              {status.result === "expired" ? "セッション期限切れ" : "確認できませんでした"}
            </div>
            {err && <p className="text-rose-600 text-sm mt-2">{err}</p>}
            <p className="text-sm text-stone-500 mt-2">もう一度お試しください。</p>
            <button onClick={() => nav(`/t/${slug}/billing/setup`)} className="mt-5 rounded-full bg-stone-900 text-white font-semibold px-5 py-2">再度登録する</button>
          </>
        )}
      </div>
    </div>
  );
}
